import { ReferralStatus, RegistrationStatus } from '../account/Account.model';

export type TokenResponse = {
  token: string;
  expiresIn: string;
};

export interface GameAccount {
  avatarUrl: string;
  createdAt: string;
  id: string;
  profileUrl: string;
  type: string;
  updatedAt: string;
  userName: string;
  gamesOwned: string[];
}

export interface ProviderAccount {
  userName: string;
  createdAt: string;
  type: string;
}

export enum MergeStatus {
  MERGED = 'merged',
  UNMERGED = 'unmerged',
  FAILED = 'failed',
  IN_PROGRESS = 'inProgress',
  UNKNOWN = 'unknown',
}

export enum MergeOperation {
  MERGE = 'merge',
  UNMERGE = 'unmerge',
  UNKNOWN = 'unknown',
}

export interface MergedAccount {
  provider: string;
  providerId: string;
  status?: MergeStatus;
  operation?: MergeOperation;
  errorCode?: string;
}

export interface SigninPayload {
  email: string;
  password: string;
}

export interface CodePayload {
  hash: string;
  expiryDate: string;
  code: string;
}

export interface Cohort {
  cohortId: string;
  enabled: boolean;
  gameId: string;
  claimed: boolean;
}

interface ProviderKey {
  provider: string;
  key: string;
  accessCode: string;
}

export interface PreRegistrations {
  [gameId: string]: {
    [preRegistrationId: string]: PreRegistration;
  };
}

export interface PreRegistrationReferral {
  email: string;
  status: ReferralStatus;
}
export interface PreRegistration {
  name?: string;
  status?: RegistrationStatus;
  providerKey?: ProviderKey;
  referredBy?: PreRegistrationReferral;
  referrals?: PreRegistrationReferral[];
}

export interface BhvrUser {
  accounts: GameAccount[];
  authorizedProviders: string[];
  bhvrNews: boolean;
  birthDate: string;
  communicationLang: string;
  country: string;
  email: string;
  emailVerified: boolean;
  firstName: string;
  gender: string;
  lastName: string;
  nickName: string;
  requiresMfa: boolean;
  requiresPassword: boolean;
  inCohort: Cohort[];
  preRegistrations?: PreRegistrations;
}

export interface PlayerRegistrationResponse {
  player: BhvrUser;
  token?: TokenResponse;
}

interface From {
  pathname: string;
}
export interface LocationState {
  from: From;
}
export interface SigninWithProviderPayload {
  idToken: string;
}

export interface ProviderPayload {
  provider: string;
  parameters: {
    email?: string;
    password?: string;
    idToken?: string;
  };
}
export interface RegisterProvider {
  idToken: string;
  type: string;
  email: string;
}

export interface SignupPayload extends ProviderPayload {
  country: string;
  birthDate: string;
  gender: string;
  bhvrNews: boolean;
  nickName: string;
  communicationLang: string;
}

export interface Availability {
  available: boolean;
}

export interface UserContext {
  user: BhvrUser;
  isUserLoad: boolean;
  signin: (payload: SigninPayload, reCaptchaToken?: string, code?: CodePayload) => Promise<void>;
  signinWithProvider: (
    payload: SigninWithProviderPayload,
    type: string,
    email: string,
    code?: CodePayload,
  ) => Promise<void>;
  register: (payload: SignupPayload, email: string, password: string, reCaptchaToken?: string) => Promise<void>;
  logout: () => Promise<void>;
  getPlayer: () => Promise<void>;
  checkPlayerAvailability: (email: string) => Promise<Availability>;
  updateUser: (user: BhvrUser) => void;
}

export interface RoutePrams {
  gameId: string;
}
